// src/services/AuthService.js
import ApiService from '../base/BaseApiService';

/**
 * ログイン認証を行う
 * @param {string} accountname - アカウント名（メールアドレス）
 * @param {string} password - パスワード
 * @param {string} userType - ユーザータイプ（'管理者', '代理店', '募集人'）
 * @returns {Promise<Object>} - アクセストークンを含むレスポンス
 */
export const login = async (accountname, password, userType = '') => {
  try {
    // FormDataオブジェクトを作成（APIの仕様に合わせる）
    const formData = new FormData();
    formData.append('username', accountname);
    formData.append('password', password);
    formData.append('login_user_type', userType);
    
    // CSRF保護付きのログインリクエスト
    const result = await ApiService.postWithCSRF('/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    });
    
    // ログイン成功後はCSRFトークンをクリア（使い捨てのため）
    ApiService.clearCSRFToken();
    return result;
  } catch (error) {
    console.error('Login error:', error);
    
    // ログイン失敗時もCSRFトークンをクリア
    ApiService.clearCSRFToken();

    // CSRFトークンの再取得
    await prepareLoginForm();
    throw error;
  }
};

/**
 * ログアウト処理を行う
 * @returns {Promise<Object>} - ログアウト結果
 */
export const logout = async () => {
  try {
    const result = await ApiService.post('/logout');
    
    // ログアウト時にCSRFトークンもクリア
    ApiService.clearCSRFToken();
    return result;
  } catch (error) {
    console.error('Logout error:', error);
    
    // エラーが発生してもCSRFトークンはクリア
    ApiService.clearCSRFToken();
    throw error;
  }
};

/**
 * パスワードリセットトークンの有効性を検証する
 * @param {string} token - 検証するトークン
 * @returns {Promise<Object>} - トークンの有効性
 */
export const validateResetToken = async (token) => {
  try {
    return await ApiService.get(`/validate-reset-token?token=${encodeURIComponent(token)}`);
  } catch (error) {
    console.error('Token validation error:', error);
    throw error;
  }
};

/**
 * CSRFトークンを事前に取得する（ログインフォーム表示時に使用）
 * @returns {Promise<string>} CSRFトークン
 */
export const prepareLoginForm = async () => {
  try {
    const csrfToken = await ApiService.getCSRFToken();
    return csrfToken;
  } catch (error) {
    console.error('ログインフォーム準備中にエラーが発生:', error);
    throw error;
  }
};

export default {
  login,
  logout,
  validateResetToken,
  prepareLoginForm
};